import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import styled from "styled-components";
import media from "styled-media-query";
import { ProductScheme, Track } from "client-v2";

import { Button, ColorV2 } from "@adoptaunabuelo/react-components";
import Container from "../../components/landing/Container";
import { State } from "../../redux";
import Header from "./Header";
import Info from "./Info";
import UnaCartaParaUnAbueloIcon from "../../assets/logo/UnaCartaParaUnAbuelo";

const HeaderSection = styled.div`
	display: flex;
	flex: 1;
	justify-content: space-between;
	${media.lessThan("medium")`
       flex: unset;
    `}
`;
const IconView = styled.div`
	display: flex;
	align-items: center;
	padding-left: 16px;
	border-left: 1px solid ${ColorV2.text.neutralHard};
	${media.lessThan("medium")`
       border-left: none;
    `}
`;

const Detail = (props: DetailProps) => {
	const view = "pack";
	const navigate = useNavigate();
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	useEffect(() => {
		//Track on Mixpanel
		Track.event({
			event: "shop product detail view init",
			user: currentUser,
			params: {
				view: view,
			},
		});
	}, []);

	const onNextClick = () => {
		navigate(`/shop/?id=${props.product.objectId}`, {
			state: {
				product: props.product,
				view: view,
			},
		});
	};

	return (
		<Container
			style={{ backgroundColor: "white" }}
			contentStyle={{ paddingTop: 0 }}
			headerProps={{
				logoBackgroundColor: "transparent",
				childrenPosition: isMobile ? "right" : "left",
				style: { position: isMobile ? "absolute" : "fixed", top: 0 },
				contentStyle: { flex: 1 },
				children: (
					<HeaderSection>
						<IconView>
							<UnaCartaParaUnAbueloIcon version="2025" />
						</IconView>
						{!isMobile && (
							<Button
								style={{
									padding: "10px 20px",
									height: "unset",
								}}
								onClick={onNextClick}
							>
								Quiero mi Pack Solidario
							</Button>
						)}
					</HeaderSection>
				),
			}}
			footerProps={{
				style: { backgroundColor: "transparent" },
				buttonProps: {
					style: {
						width: "100%",
					},
					children: `Quiero mi Pack Solidario`,
					onClick: onNextClick,
				},
			}}
		>
			<Header product={props.product} view={view} />
			<Info product={props.product} view={view}/>
		</Container>
	);
};
export default Detail;
export interface DetailProps {
	product: ProductScheme;
}
